var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 69,
    viewBox: "0 0 62 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0486 59.2193C45.8739 58.6245 48.253 57.4349 50.1861 55.6134C53.0486 52.8996 53.4575 49.2565 53.4575 44.684V24.2751C53.4575 19.7026 53.0486 16.0595 50.1861 13.3457C48.253 11.5242 45.8739 10.3346 43.0486 9.73977V0C47.6954 0.669145 51.5616 2.41636 54.5727 5.27881C58.5132 8.99628 61.9705 14.0149 61.9705 20.3346V48.2156C61.9705 54.5353 58.5132 59.5539 54.5727 63.2714C51.5616 66.1338 47.6954 67.881 43.0486 68.5502V59.2193Z",
    fill: "url(#paint0_linear_8591_71621)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39806 5.27881C10.4092 2.41636 14.2754 0.669145 18.9222 0V9.77696C16.0969 10.3718 13.7178 11.5613 11.7847 13.3829C8.92222 16.0967 8.5133 19.7026 8.5133 24.2379V44.7212C8.5133 49.2937 8.92222 52.9368 11.7847 55.6506C13.7178 57.4722 16.0969 58.6617 18.9222 59.2565V68.5874C14.2754 67.9183 10.4092 66.171 7.39806 63.3086C3.45754 59.5911 0.000297056 54.5725 0.000297056 48.2528V20.2231C-0.0368776 13.9777 3.42037 8.99629 7.39806 5.27881Z",
    fill: "url(#paint1_linear_8591_71621)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4798 26.9145L42.6397 21.8216L36.0226 18.3271L33.2345 23.606C32.8256 24.3866 32.0821 24.8327 31.1899 24.8327C30.3349 24.8327 29.5542 24.3866 29.1453 23.606L26.3943 18.3271L19.8144 21.7844L24.3869 29.1078L39.4798 26.9145Z",
    fill: "url(#paint2_linear_8591_71621)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7326 30.5948L15.0932 30.8922V37.4721L25.3163 37.435L19.8144 46.2825L26.3943 49.7398L29.1824 44.461C29.5914 43.6803 30.3349 43.2342 31.227 43.2342C32.0821 43.2342 32.8627 43.6803 33.2717 44.461L36.0598 49.7398L42.6769 46.2454L38.2159 39.0706L29.6285 37.3978L47.7326 37.3234V30.5948Z",
    fill: "url(#paint3_linear_8591_71621)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8591_71621",
    x1: 20.2203,
    y1: 76.8599,
    x2: 63.5789,
    y2: 9.52659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.48144e-7,
    stopColor: "#0884B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4173,
    stopColor: "#70CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#86C440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8591_71621",
    x1: -3.33167,
    y1: 61.6939,
    x2: 40.027,
    y2: -5.63947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.48144e-7,
    stopColor: "#0884B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4173,
    stopColor: "#70CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#86C440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8591_71621",
    x1: 2.98462,
    y1: 65.7611,
    x2: 46.3432,
    y2: -1.5722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.48144e-7,
    stopColor: "#0884B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4173,
    stopColor: "#70CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#86C440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8591_71621",
    x1: 8.90926,
    y1: 69.5763,
    x2: 52.2679,
    y2: 2.24294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.48144e-7,
    stopColor: "#0884B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4173,
    stopColor: "#70CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#86C440"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8de6c587f8df6d7dce812bc9ffd59f73.svg";
export { ForwardRef as ReactComponent };